import React from "react";
import { Category } from "../../types";

interface Props {
  categories: Category[];
  activeCategories: Category[];
  onMouseEnterCategory: (cat: Category, level: number) => void;
  onClickCategory: (cat: Category) => void;
}

const DesktopCategoryCols: React.FC<Props> = ({
  categories,
  activeCategories,
  onMouseEnterCategory,
  onClickCategory
}) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "start",
        alignItems: "flex-start",
      }}
    >
      {/* Первая колонка: корневые категории */}
      <div
        style={{
          width: 250,
          maxHeight: "calc(100vh - 100px)", // Высота адаптивна под экран
          overflowY: "auto",
          // borderRight: "1px solid #ddd",
          marginRight: 16,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
          {categories.map((category) => (
            <li
              key={category.id}
              style={{
                cursor: "pointer",
                padding: "5px 0px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "14px",
                fontWeight:
                  activeCategories[0]?.id === category.id ? "bold" : "normal",
              }}
              onMouseEnter={() => onMouseEnterCategory(category, 0)}
              onClick={() => onClickCategory(category)}
            >
              {category.name}
              {category.children && category.children.length > 0 &&
                <div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={`${activeCategories[0]?.id === category.id ? 2.5 : 1.5}`} stroke={`${activeCategories[0]?.id === category.id ? "black" : "gray"}`} className="size-3">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
                </div>
              }
            </li>
          ))}
        </ul>
      </div>

      {/* Остальные колонки для "активных" категорий */}
      {activeCategories.map((activeCat, index) => {
        const children = activeCat.children || [];
        if (children.length === 0) return null;
        return (
          <div
            key={activeCat.id}
            style={{
              width: 270,
              maxHeight: "calc(100vh - 100px)", // Высота ограничена экраном
              overflowY: "auto",
              // borderRight: "1px solid #ddd",
              marginRight: 16,
              display: "flex",
              flexDirection: "column"
            }}
          >
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {children.map((child) => (
                <li
                  key={child.id}
                  style={{
                    cursor: "pointer",
                    padding: "5px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight:
                      activeCategories[index + 1]?.id === child.id
                        ? "bold"
                        : "normal",
                  }}
                  onMouseEnter={() => onMouseEnterCategory(child, index + 1)}
                  onClick={() => onClickCategory(child)}
                >
                  {child.name}
                  {child.children && child.children.length > 0 &&
                    <div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={`${activeCategories[index + 1]?.id === child.id ? 2.5 : 1.5}`} stroke={`${activeCategories[index + 1]?.id === child.id ? "black" : "gray"}`} className="size-3">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                    </div>
                  }
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default DesktopCategoryCols;
